class AnimateHeartCanvas {
    /**
     * @param hMin 颜色 h 最小值
     * @param hMax 颜色 h 最大值
     * @param countHeart 心的数量
     * @param sizeMin 心形最小值
     * @param sizeMax 心形最大值
     * @param bgColor 背景颜色
     * @param containerRef The container element to append the canvas
     */
    constructor(hMin, hMax, countHeart = 150, sizeMin = 50, sizeMax = 350, bgColor, containerRef) {
      this.isPlaying = true; // 默认自动播放
  
      this.mouseX = 0;
      this.mouseY = 0;
  
      this.containerRef = containerRef;
  
      this.configFrame = {
        width: 1200,
        height: 300,
        bgColor: bgColor
      };
      this.configHeart = {
        timeLine: 0,
        timeInit: new Date().getTime(),
        movement: 1,
        countHeart: countHeart || 150,
        sizeMin: isNaN(sizeMin) ? 10 : sizeMin,
        sizeMax: isNaN(sizeMax) ? 50 : sizeMax,
        colorSaturate: 100,
        colorLight: 60,
        hMin: isNaN(hMin) ? 0 : hMin,
        hMax: isNaN(hMax) ? 10 : hMax,
        minOpacity: 20,
        maxOpacity: 100,
        opacityGrowth: 5,
        heartRangeMin: 0,
        heartRangeMax: 0.3,
        gravityMin: 1,
        gravityMax: 9.8,
        flowDirection: -1
      };
  
      this.heartBuffer = []; // 心缓存
  
      this.init();
      window.onresize = () => this.updateCanvasSize();
    }
  
    init() {
      const canvas = document.createElement("canvas");
      this.containerRef.appendChild(canvas);
      canvas.id = "heartLayer";
      this.updateCanvasSize();
  
      this.configHeart.timeLine = 0;
  
      for (let i = 0; i < this.configHeart.countHeart; i++) {
        let randomSize = randomInt(this.configHeart.sizeMin, this.configHeart.sizeMax);
        let x = randomInt(0, this.configFrame.width);
        let y = randomInt(
          this.configFrame.height * (1 - this.configHeart.heartRangeMax),
          this.configFrame.height * (1 - this.configHeart.heartRangeMin)
        );
        this.heartBuffer.push({
          id: i,
          gravity: randomFloat(this.configHeart.gravityMin, this.configHeart.gravityMax),
          opacity: 1,
          opacityFinal: randomInt(this.configHeart.minOpacity, this.configHeart.maxOpacity),
          timeInit: randomInt(1, 500),
          x,
          y,
          originalX: x,
          originalY: y,
          width: randomSize,
          height: randomSize,
          colorH: randomInt(this.configHeart.hMin, this.configHeart.hMax)
        });
      }
  
      this.draw();
  
      document.documentElement.addEventListener("mousemove", event => {
        this.mouseX = event.x;
        this.mouseY = event.y;
      });
    }
  
    updateCanvasSize() {
      const { offsetWidth, offsetHeight } = this.containerRef;
      const canvas = document.getElementById("heartLayer");
      
      if (canvas) {
        canvas.width = offsetWidth;
        canvas.height = offsetHeight;
        this.configFrame.width = offsetWidth;
        this.configFrame.height = offsetHeight;
        const canvasStyle = canvas.style;
        canvasStyle.position = "absolute";
        canvasStyle.top = "0";
        canvasStyle.left = "0";
        canvasStyle.zIndex = "-1"; // Make sure the canvas is behind other elements
      } else {
        console.log("Heart Layer Not Found");
      }
    }
  
    play() {
        console.log("Animation started")
        console.log(this.isPlaying)
      if (this.isPlaying) {
        this.draw();
      } else {
        this.isPlaying = true;
        this.draw();
      }
    }
  
    stop() {
        console.log("Animation Stopped")
      this.isPlaying = false;
    }
  
    destroy() {
        this.isPlaying = false;

        // Get the canvas element
        let heartLayer = document.getElementById('heartLayer');
    
        // Check if the canvas element exists before trying to remove it
        if (heartLayer) {
            heartLayer.remove();
            console.log('animation stopped');
        } else {
            console.log('Canvas element not found, cannot remove');
        }
    }
  
    draw() {
    
      this.configHeart.timeLine = this.configHeart.timeLine + 1;
  
      let canvasHeart = document.getElementById("heartLayer");
    
        if (!canvasHeart) {
        console.error('Canvas element not found!');
        return; // Exit if canvas is not found
    }
      let contextHeart = canvasHeart.getContext("2d");
      contextHeart.clearRect(0, 0, this.configFrame.width, this.configFrame.height);
  
      if (this.configFrame.bgColor) {
        contextHeart.fillStyle = this.configFrame.bgColor;
        contextHeart.fillRect(0, 0, this.configFrame.width, this.configFrame.height);
      }
  
      this.heartBuffer.forEach(heart => {
        if (heart.y < -(heart.height)) {
          heart.y = heart.originalY;
          heart.timeInit = this.configHeart.timeLine;
          heart.opacity = 0;
        }
  
        let timeGap = this.configHeart.timeLine - heart.timeInit;
        if (timeGap > 0) {
          heart.opacity = heart.opacity * ((this.configHeart.timeLine - heart.timeInit) / 100);
        } else {
          heart.opacity = 0;
        }
  
        if (heart.opacity >= heart.opacityFinal) {
          heart.opacity = heart.opacityFinal;
        }
  
        let movement = 1 / 2 * heart.gravity * (this.configHeart.timeLine - heart.timeInit) / 300 * this.configHeart.flowDirection;
        heart.y = heart.y - movement;
  
        this.drawHeart(
          heart.x,
          heart.y,
          heart.width / 2,
          heart.height / 2,
          `hsl(${heart.colorH} ${this.configHeart.colorSaturate}% ${this.configHeart.colorLight}% / ${heart.opacity}%)`
        );
  
        heart.opacity = heart.opacity + this.configHeart.opacityGrowth;
      });
  
      if (this.isPlaying) {
        window.requestAnimationFrame(() => {
          this.draw();
        });
      }
    }
  
    drawHeart(x, y, width, height, colorFill) {
      let canvasHeart = document.getElementById("heartLayer");
      let contextHeart = canvasHeart.getContext("2d");
  
      contextHeart.save();
      contextHeart.beginPath();
      let topCurveHeight = height * 0.3;
      contextHeart.moveTo(x, y + topCurveHeight);
  
      contextHeart.bezierCurveTo(x, y, x - width / 2, y, x - width / 2, y + topCurveHeight);
      contextHeart.bezierCurveTo(x - width / 2, y + (height + topCurveHeight) / 2, x, y + (height + topCurveHeight) / 1.4, x, y + height);
      contextHeart.bezierCurveTo(x, y + (height + topCurveHeight) / 1.8, x + width / 2, y + (height + topCurveHeight) / 2, x + width / 2, y + topCurveHeight);
      contextHeart.bezierCurveTo(x + width / 2, y, x, y, x, y + topCurveHeight);
  
      contextHeart.closePath();
      contextHeart.fillStyle = colorFill;
      contextHeart.fill();
      contextHeart.restore();
    }
  }
  
  function randomDirection() {
    let random = Math.random();
    return random > 0.5 ? 1 : -1;
  }
  
  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }
  
  function randomFloat(min, max) {
    return Math.random() * (max - min) + min;
  }
  
  export { AnimateHeartCanvas };
  